import { useMemo } from "react";
import { RotateCcw } from "lucide-react";
import DOMPurify from "dompurify";

import { formatDate } from "@/utils/dateFormatter";
import CustomBadge from "../../../../components/desktop/badge/CustomBadge";
import CustomDropdown from "@/components/desktop/list/dropdown/CustomDropdown";

const MOVEMENT_TYPE_INVENTORY_DELETED = 16;

export function useOtherMovementsHistoryColumns({ onRestore } = {}) {
	return useMemo(() => {
		const columns = [
			{
				Header: "Fecha Registro",
				accessor: "movement_date",
				width: "10%",
				Cell: ({ value }) => formatDate(value),
			},
			{ Header: "Campo", accessor: "estate_parent_name", width: "10%" },
			{
				Header: "Tipo Movimiento",
				accessor: "movement_type",
				width: "20%",
				Cell: ({ value }) => <CustomBadge variant="neutral">{value}</CustomBadge>,
			},
			{
				Header: "Descripción",
				accessor: "description",
				Cell: ({ value }) => (
					<div
						dangerouslySetInnerHTML={{
							__html: DOMPurify.sanitize(value || ""),
						}}
					/>
				),
			},
		];

		if (onRestore) {
			columns.push({
				Header: "",
				accessor: "_actions",
				disableSortBy: true,
				width: "3%",
				Cell: ({ row }) => {
					const canRestore =
						row.original.movement_type_id === MOVEMENT_TYPE_INVENTORY_DELETED &&
						row.original.inventory_id != null &&
						Boolean(row.original.inventory_deleted);

					if (!canRestore) return null;

					const items = [
						{
							label: "Restaurar",
							action: () => onRestore(row.original.inventory_id),
							icon: RotateCcw,
						},
					];

					return (
						<div style={{ textAlign: "center" }}>
							<CustomDropdown title="Acciones" items={items} align="right" />
						</div>
					);
				},
			});
		}

		return columns;
	}, [onRestore]);
}
